import { Card } from "@/components/ui/card";
import { classNames } from "@/lib/format";

export default function MetricCard({ label, value, delta, icon: Icon, accent, testid }) {
  const accentCls = {
    primary: "text-primary bg-primary/10",
    emerald: "text-[hsl(var(--emerald))] bg-[hsl(var(--emerald)/0.12)]",
    amber: "text-[hsl(var(--amber))] bg-[hsl(var(--amber)/0.12)]",
    rose: "text-[hsl(var(--rose))] bg-[hsl(var(--rose)/0.12)]",
  }[accent] || "text-primary bg-primary/10";

  return (
    <Card className="p-5" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-wider text-muted-foreground font-medium">
            {label}
          </div>
          <div className="font-display mt-2 font-mono text-3xl font-bold tracking-tight">
            {value}
          </div>
          {delta && (
            <div className={classNames("mt-1 text-xs font-medium", delta.positive ? "text-[hsl(var(--emerald))]" : "text-muted-foreground")}>
              {delta.text}
            </div>
          )}
        </div>
        {Icon && (
          <div className={classNames("h-10 w-10 rounded-lg flex items-center justify-center", accentCls)}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
    </Card>
  );
}
